export default class ApiClientsJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.apiClientsEndpoint, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.apiClientsEndpoint}/${id}`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.apiClientsEndpoint}/${id}`)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.apiClientsEndpoint, {
      params
    })
  }

  get(id) {
    return this.axiosIns.get(`${this.jwtConfig.main.apiClientsEndpoint}/${id}`)
  }

  regenerateSecret(id) {
    return this.axiosIns.post(`${this.jwtConfig.main.apiClientsEndpoint}/${id}/regenerate-secret`)
  }

  usageOverview(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.apiClientsEndpoint}/usage`, { params })
  }

  usageAnomalies(params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.apiClientsEndpoint}/usage/anomalies`, { params })
  }

  usage(id, params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.apiClientsEndpoint}/${id}/usage`, { params })
  }

  usageLogs(id, params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.apiClientsEndpoint}/${id}/usage/logs`, { params })
  }

  usageErrors(id, params = {}) {
    return this.axiosIns.get(`${this.jwtConfig.main.apiClientsEndpoint}/${id}/usage/errors`, { params })
  }

  registry() {
    return this.axiosIns.get(`${this.jwtConfig.main.apiClientsEndpoint}/registry`)
  }
}
